"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInstallationPanel = getInstallationPanel;

var _preact = require("preact");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _PanelItems = require("../PanelItems");

var InstallationPanelBody = function InstallationPanelBody(_ref) {
  var isInstalled = _ref.isInstalled,
      _onSave = _ref.onSave,
      _onCancel = _ref.onCancel,
      _onChangeCallback = _ref.onChangeCallback,
      onClickCallback = _ref.onClickCallback,
      errorMessage = _ref.errorMessage,
      accessToken = _ref.accessToken,
      _onClickManage = _ref.onClickManage,
      _onClickUninstall = _ref.onClickUninstall,
      isSavingCredentials = _ref.isSavingCredentials;
  return (0, _preact.h)("div", {
    className: "panel-body-container installation__panel_body"
  }, (0, _preact.h)("div", null, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    title: "Access token",
    meta: "You can generate a new token in Productboard app > Workspace Settings > Integrations > Public API > Access Token.",
    key: "accessToken",
    error: errorMessage,
    required: true,
    showIconBeforeErrorMessage: true,
    qaClasses: "qa-productboard-access-token",
    value: accessToken,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return _onChangeCallback(e.target.value);
    },
    onClick: function onClick() {
      return onClickCallback();
    }
  })), isInstalled ? (0, _preact.h)(_PanelItems.ManageInstallationButtons, {
    onClickManage: function onClickManage() {
      return _onClickManage();
    },
    onClickUninstall: function onClickUninstall() {
      return _onClickUninstall();
    }
  }) : (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: function onSave() {
      return _onSave();
    },
    onCancel: function onCancel() {
      return _onCancel();
    },
    primaryButtonVariantType: "brand",
    primaryButtonText: "Install",
    isLoading: isSavingCredentials
  }));
};

function getInstallationPanel(props) {
  var isInstalled = props.isInstalled,
      _onSave2 = props.onSave,
      _onCancel2 = props.onCancel,
      errorMessage = props.errorMessage,
      _onClickManage2 = props.onClickManage,
      _onClickUninstall2 = props.onClickUninstall,
      hasUnsavedChanges = props.hasUnsavedChanges,
      _onChangeCallback2 = props.onChangeCallback,
      _onClickCallback = props.onClickCallback,
      accessToken = props.accessToken,
      isSavingCredentials = props.isSavingCredentials;
  return {
    body: (0, _preact.h)(InstallationPanelBody, {
      isInstalled: isInstalled,
      onSave: function onSave() {
        return _onSave2();
      },
      onCancel: function onCancel() {
        return _onCancel2();
      },
      onChangeCallback: function onChangeCallback(accessToken) {
        return _onChangeCallback2(accessToken);
      },
      onClickCallback: function onClickCallback() {
        return _onClickCallback();
      },
      onClickManage: function onClickManage() {
        return _onClickManage2();
      },
      onClickUninstall: function onClickUninstall() {
        return _onClickUninstall2();
      },
      accessToken: accessToken,
      errorMessage: errorMessage,
      isSavingCredentials: isSavingCredentials
    }),
    customClass: 'panel__body_without_header',
    hasUnsavedChanges: hasUnsavedChanges
  };
}